import { alpha, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';
import { observer } from 'mobx-react-lite';

import useIsMessagingReconnecting from '~hooks/useMessaging/useIsMessagingReconnecting';

const MessagingReconnectingBanner = observer(() => {
  const theme = useTheme();
  const isReconnecting = useIsMessagingReconnecting();

  if (!isReconnecting) return null;

  return (
    <Box
      data-test-id="messaging-reconnecting-banner"
      role="status"
      sx={{
        alignItems: 'center',
        backgroundColor: alpha(theme.brandV2.colors.treadYellow, 0.15),
        borderBottom: `1px solid ${theme.brandV2.colors.treadYellow}`,
        color: theme.brandV2.colors.treadBlack,
        display: 'flex',
        flexShrink: 0,
        gap: 1,
        px: 2,
        py: 0.5,
      }}
    >
      <CircularProgress color="inherit" size={12} />
      <Typography variant="caption">{t('messaging.reconnecting')}</Typography>
    </Box>
  );
});

export default MessagingReconnectingBanner;
